import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import SccTouchableOpacity from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function V2TabBar({ items, current, onChange, }) {
    return (_jsxs(Container, { children: [_jsx(TabRow, { children: items.map(({ value, label }) => {
                    const active = current === value;
                    return (_jsxs(TabButton, { elementName: `${value}_tab_button`, onPress: () => onChange(value), children: [_jsx(TabLabelWrapper, { active: active, children: _jsx(TabLabel, { active: active, children: label }) }), active && _jsx(ActiveIndicator, {})] }, String(value)));
                }) }), _jsx(Divider, {})] }));
}
const Container = styled.View `
  background-color: ${color.white};
`;
const TabRow = styled.View `
  flex-direction: row;
`;
const TabButton = styled(SccTouchableOpacity) `
  flex: 1;
  align-items: center;
`;
const TabLabelWrapper = styled.View `
  padding-vertical: 12px;
`;
const TabLabel = styled.Text `
  font-family: ${({ active }) => active ? font.pretendardBold : font.pretendardMedium};
  font-size: 14px;
  color: ${({ active }) => (active ? color.gray80 : color.gray60)};
`;
const ActiveIndicator = styled.View `
  width: 100%;
  height: 2px;
  border-radius: 30px;
  background-color: ${color.gray80};
`;
const Divider = styled.View `
  height: 1px;
  background-color: ${color.gray20};
`;
